module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/21988681fa28c8ce37982ca26463a6f5.svg";